module.exports = __webpack_public_path__ + "img/icon-cbd.5fcfeafa.png";